<template>
	<input v-model="bufferValue" type="text" class="form-control outline-secondary" :placeholder="placeholder">
</template>

<script>
	export default {
		name: 'ReInputAmount',
		components: {

		},
		props: {
			value: [String,Number], //String, //[String,Number]
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			placeholder: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				bufferValue:'',
			}
		},
		watch:{
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){
				if(typeof val == 'number') val = val.toString();
				val = this.$GVO.str_replace(' ','',val);
				let number1 = this.$GVO.number_format(val,0,'.',' ');
				if(number1 == 0 ){ number1= ''; }
				this.bufferValue = number1;
				if(this.value != this.bufferValue){
					this.$emit("input", this.bufferValue);
				}
			},
		},
		computed: {

		},
		methods: {
			
		},
		mounted() {
			this.bufferValue = this.value;
		}
	}
</script>
<style scoped>

</style>
